import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { qk } from '@/lib/query-client'
import { useWorkspace } from '@/providers/workspace-provider'

/**
 * Assina mudanças em tempo real do workspace atual e invalida as queries.
 * O Realtime respeita a RLS — só chega o que o usuário pode ver.
 * Montado uma vez no layout autenticado.
 */
export function useRealtime() {
  const { workspaceId } = useWorkspace()
  const qc = useQueryClient()

  useEffect(() => {
    if (!workspaceId) return
    const wsFilter = `workspace_id=eq.${workspaceId}`

    const channel = supabase
      .channel(`ws:${workspaceId}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'tasks', filter: wsFilter },
        () => {
          void qc.invalidateQueries({ queryKey: qk.tasks(workspaceId) })
          void qc.invalidateQueries({ queryKey: qk.dashboard(workspaceId) })
        },
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'notifications', filter: wsFilter },
        () => {
          void qc.invalidateQueries({ queryKey: qk.notifications(workspaceId) })
        },
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'editorial_calendar', filter: wsFilter },
        () => {
          void qc.invalidateQueries({ queryKey: qk.calendar(workspaceId) })
        },
      )
      .on('postgres_changes', { event: '*', schema: 'public', table: 'approvals' }, () => {
        void qc.invalidateQueries({ queryKey: qk.approvals(workspaceId) })
      })
      .subscribe()

    return () => {
      void supabase.removeChannel(channel)
    }
  }, [workspaceId, qc])
}
